<script setup lang="ts">
import { onMounted, reactive } from 'vue'
import { storeToRefs } from 'pinia'
import { useManagementStore } from '@/store/management'
import { useSuccessStore } from '@/store/success'
import { ALARM_TYPE_LABELS } from '@/interfaces/enums'

// Configuração das metas (limites ideais) de quantidade de alarmes por tipo.
// Usadas no Resumo Gerencial do relatório para comparar meta × realizado.
const store = useManagementStore()
const { savingAlarmTargets } = storeToRefs(store)

const rows = Object.entries(ALARM_TYPE_LABELS).map(([key, label]) => ({ key, label }))

// alarm_type -> valor digitado (string para permitir vazio = "sem meta").
const values = reactive<Record<string, string>>({})

onMounted(async () => {
  await store.fetchAlarmTargets()
  store.alarmTargets.forEach((target) => {
    values[target.alarm_type] = String(target.target_count)
  })
})

async function save() {
  const targets = rows
    .filter((row) => values[row.key] !== undefined && values[row.key] !== '' && !Number.isNaN(Number(values[row.key])))
    .map((row) => ({ alarm_type: row.key, target_count: Math.max(0, Math.round(Number(values[row.key]))) }))

  const ok = await store.saveAlarmTargets(targets)
  if (ok) useSuccessStore().setSuccess(['Metas de alarme salvas.'])
}
</script>

<template>
  <div class="bg-white shadow-4">
    <div class="flex flex-wrap items-center justify-between gap-3 border-b-2 border-stroke px-6 py-4">
      <div>
        <h2 class="font-satoshi text-base font-bold text-black">Limites de alarme (metas)</h2>
        <p class="mt-1 text-sm text-slate-500">Quantidade ideal de alarmes por tipo no período. Usada no relatório (meta × realizado). Deixe em branco para não definir meta.</p>
      </div>
      <button
        type="button"
        class="rounded bg-primary px-4 py-2 text-sm font-medium text-white transition hover:bg-opacity-90 disabled:cursor-not-allowed disabled:opacity-50"
        :disabled="savingAlarmTargets"
        @click="save">
        {{ savingAlarmTargets ? 'Salvando…' : 'Salvar metas' }}
      </button>
    </div>

    <div class="grid grid-cols-1 gap-4 p-4 sm:grid-cols-2 lg:grid-cols-3 xl:p-6">
      <label v-for="row in rows" :key="row.key" class="flex items-center justify-between gap-3 border border-stroke px-3 py-2">
        <span class="text-sm font-medium text-slate-700">{{ row.label }}</span>
        <input
          v-model="values[row.key]"
          type="number"
          min="0"
          step="1"
          placeholder="—"
          class="w-20 border-2 border-stroke px-2 py-1 text-right font-satoshi text-sm text-body outline-none" />
      </label>
    </div>
  </div>
</template>
